import React from 'react'
import Header from "./Components/Index/Header/Header";
import Footer from "./Components/Index/Footer/Footer";


const App=()=> {
  return (
   <> 
     <Header />
      <Footer /> 
    </>
  )
}

export default App;
